var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDotGridSm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 124,
    height: 44,
    viewBox: "0 0 124 44",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    fill: "#0B75E0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 102,
    cy: 2,
    r: 2,
    fill: "#0B75E0"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 2,
    r: 2,
    fill: "#0B75E0"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 122,
    cy: 2,
    r: 2,
    fill: "#0B75E0"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 2,
    r: 2,
    fill: "#0B75E0"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 2,
    r: 2,
    fill: "#0B75E0"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 2,
    r: 2,
    fill: "#0B75E0"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 42,
    r: 2,
    fill: "#0B75E0"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 102,
    cy: 42,
    r: 2,
    fill: "#0B75E0"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 42,
    r: 2,
    fill: "#0B75E0"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 122,
    cy: 42,
    r: 2,
    fill: "#0B75E0"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 2,
    fill: "#0B75E0"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 42,
    r: 2,
    fill: "#0B75E0"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 42,
    r: 2,
    fill: "#0B75E0"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 22,
    r: 2,
    fill: "#0B75E0"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 102,
    cy: 22,
    r: 2,
    fill: "#0B75E0"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 2,
    fill: "#0B75E0"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 122,
    cy: 22,
    r: 2,
    fill: "#0B75E0"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 22,
    r: 2,
    fill: "#0B75E0"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 22,
    r: 2,
    fill: "#0B75E0"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 22,
    r: 2,
    fill: "#0B75E0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotGridSm);
export default __webpack_public_path__ + "static/media/DotGridSm.9ee56ddcae17ebc1215f1fbc70c2a0ca.svg";
export { ForwardRef as ReactComponent };